import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
import {
  Warning as WarningIcon,
} from '@mui/icons-material';
import { PermissionUtils } from './types';

interface DeleteApplicationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirmDelete: () => Promise<void>;
  isLoading: boolean;
  permissionUtils: PermissionUtils;
}

const DeleteApplicationDialog: React.FC<DeleteApplicationDialogProps> = ({
  open,
  onClose,
  onConfirmDelete,
  isLoading,
  permissionUtils
}) => {
  const { canPerformAction } = permissionUtils;

  // Only render if user has permission to delete
  if (!canPerformAction('deleteApplication')) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <WarningIcon sx={{ mr: 1, color: 'error.main' }} />
        Delete Application
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          Are you sure you want to delete this application? This action cannot be undone.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          All associated data, including API keys, user data, and configuration settings will be permanently removed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onConfirmDelete}
          color="error"
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? 'Deleting...' : 'Delete Application'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteApplicationDialog;